import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface AccountState {
    /** 余额 */
    wallet: number | null;
    /** 余额明细 */
    walletDetail: ListWrap<User.WalletTally> & ListRequesting;
}

const m: Module<AccountState, RootState> = {
    namespaced: true,
    state: {
        wallet: null,
        walletDetail: {
            list: [],
            loaded: false,
            requesting: false,
        },
    },
    mutations: {
        /**
         * 记录wallet数据
         */
        setWallet(state, wallet) {
            state.wallet = wallet;
        },
        /**
         * 记录余额明细
         */
        concatWalletDetail(state, list) {
            state.walletDetail.list.push(...list);
        },
        /**
         * 记录余额全部加载
         */
        setWalletDetailLoaded(state, loaded) {
            state.walletDetail.loaded = loaded;
        },
        /**
         * 记录余额正在请求
         */
        setWalletDetailReq(state, req) {
            state.walletDetail.requesting = req;
        },
    },
    actions: {
        /**
         * 获得余额
         */
        async getWallet({ state, commit }) {
            const response = await Vue.axios.get('/api/v1/user/wallet');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setWallet', rdata.data);
            }
            return rdata;
        },
        /**
         * 获取余额明细
         */
        async getWalletDetail({ state, commit }, { offset, count }) {
            const wrap = state.walletDetail;
            if (wrap.loaded || wrap.requesting) {
                return;
            }
            const end = offset + count;
            const length = wrap.list.length;
            if (end <= length) {
                return;
            }
            if (offset < length) {
                offset = length;
                count = end - offset;
            }
            commit('setWalletDetailReq', true);
            const response = await Vue.axios.get('/api/v1/user/wallet_detail', {
                params: {
                    offset,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                const list = rdata.data;
                commit('concatWalletDetail', list);
                if (list.length < count) {
                    commit('setWalletDetailLoaded', true);
                }
            }
            commit('setWalletDetailReq', false);
            return rdata;
        },
        /**
         * 钱包余额提现
         */
        async walletWithdraw({ dispatch }, { money }) {
            const response = await Vue.axios.get('/api/v1/user/withdrawal', {
                params: {
                    money,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                await dispatch('getWallet');
            }
            return rdata;
        },
    },
};

export default m;
